import { useContext, useMemo } from 'react';
import { NavigationContext } from '~/components/nav/nav-context';
import { useP2GMediaQueryUp } from '@parcel2go/core-ui';

const useSmartNav = () => {
  const { state } = useContext(NavigationContext);
  const isXl = useP2GMediaQueryUp('lg');
  const settings = useMemo(() => {
    const wideEnoughToSupportSideBar = isXl;

    const showSideBar = !state.disable && wideEnoughToSupportSideBar;

    return {
      ...state,
      showSideBar: showSideBar,
      showSmartActions: !state.disable && state.showSmartActions,
      home: state.home,
      maxWidth: state.disable ? false : state.maxWidth,
      showNav: !showSideBar
    };
  }, [state, isXl]);

  return settings;
};

export default useSmartNav;
